import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const NavbarWrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: #1a1a1a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 24px;
`;

const NavbarContent = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 2px;
  color: #f5e6d3;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  
  img {
    display: none;
  }
`;

const LanguageButton = styled(Button)`
  &.ant-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #f5e6d3;
    
    &:hover {
      color: #ffffff;
    }
  }
`;

const Navbar = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const toggleLanguage = () => {
    const nextLang = i18n.language === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(nextLang);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <NavbarWrapper>
      <NavbarContent>
        <Logo onClick={handleLogoClick}>
          <img src="/images/logo.svg" alt="SHCLUB" />
          SHCLUB
        </Logo>
        <Space>
          <LanguageButton 
            type="text" 
            icon={<GlobalOutlined />}
            onClick={toggleLanguage}
          >
            {i18n.language === 'zh' ? 'English' : '中文'}
          </LanguageButton>
        </Space>
      </NavbarContent>
    </NavbarWrapper>
  );
};

export default Navbar; 